import Swiper from 'swiper/bundle';

/**
 * Main Swiper initialization and configuration
 * Contains all slider-related functionality for the website
 */
document.addEventListener('DOMContentLoaded', () => {
    // Hero Slider Configuration
    const heroSlider = new Swiper('#heroSlider', {
        direction: 'horizontal',
        loop: true,
        speed: 1000,
        effect: 'slide',
        grabCursor: true,
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        keyboard: {
            enabled: true,
        },
    });

    // Custom Pagination Elements
    const paginationElements = {
        items: document.querySelectorAll('.pagination-item'),
        bullets: document.querySelectorAll('.pagination-bullet'),
        titles: document.querySelectorAll('.pagination-title')
    };

    /**
     * Updates the active state of pagination elements
     * @param {number} activeIndex - The index of the active slide
     */
    const updateActivePagination = (activeIndex) => {
        paginationElements.bullets.forEach((bullet, index) => {
            const isActive = index === activeIndex;
            bullet.classList.toggle('pagination-bullet-active', isActive);
            paginationElements.titles[index].classList.toggle('pagination-title-active', isActive);
        });
    };

    // Initialize pagination
    updateActivePagination(heroSlider.realIndex);

    // Add click handlers to pagination items
    paginationElements.items.forEach((item, index) => {
        item.addEventListener('click', () => {
            heroSlider.slideToLoop(index);
        });
    });

    // Update pagination on slide change
    heroSlider.on('slideChange', () => {
        updateActivePagination(heroSlider.realIndex);
    });

    // Why Hyundai Slider Content
    const slides = [
        {
            id: 'slide1',
            title: 'Технології ліфтів і ескалаторів світового класу',
            description: 'Hyundai Elevator впроваджує передові рішення для гарантування безпеки та надійності, зелені технології, що враховують потреби людей і природи, а також розумні інновації в поєднанні з ІТ-технологіями №1 у Кореї, що робить компанію гравцем світового рівня.',
            url: 'https://hyundaielevator.com.ua/advanced-technologies/ultra-high-speed-elevator.html'
        },
        {
            id: 'slide2',
            title: 'Надійна виробнича система',
            description: 'Виробничі заводи в Кореї (46 484 м²) та Китаї (28 716 м²) оснащені найсучаснішим обладнанням і технологіями для постачання високоякісної продукції.',
            url: 'https://hyundaielevator.com.ua/research-and-development/hyundai-asan-tower.html'
        },
        {
            id: 'slide3',
            title: 'Якість і безпека, визнані у світі',
            description: 'Безпека — найвища цінність компанії Hyundai Elevator. Щоб забезпечити максимальний комфорт і надійність, ми ретельно перевіряємо якість ще на етапі розробки.',
            url: 'https://hyundaielevator.com.ua/smart-technology/the-best-moving-solutions.html'
        },
        {
            id: 'slide4',
            title: 'Екологічне енергозбереження',
            description: 'Енергозберігаючі технології Hyundai Elevator, зокрема регенеративний інвертор, отримали світове визнання та сертифікат класу A від німецької випробувальної та сертифікаційної установи TÜV SÜD.',
            url: 'https://hyundaielevator.com.ua/green-technology/regenerative-inverter.html'
        }
    ];

    /**
     * Updates the content of the current slide
     * @param {number} index - Current slide index
     */
    const updateSlideContent = (index) => {
        const realIndex = index % slides.length;
        const elements = {
            title: document.querySelector('[data-slider-title]'),
            description: document.querySelector('[data-slider-description]'),
            url: document.querySelector('[data-slider-url]'),
            number: document.querySelector('[data-slider-number]')
        };

        if (elements.title) elements.title.textContent = slides[realIndex].title;
        if (elements.description) elements.description.textContent = slides[realIndex].description;
        if (elements.url) elements.url.href = slides[realIndex].url;
        if (elements.number) {
            elements.number.textContent = (realIndex + 1).toString().padStart(2, '0');
        }
    };

    // Why Hyundai Slider Configuration
    const whyHyundaiSlider = new Swiper('#whyHyundai', {
        slidesPerView: 1.3,
        centeredSlides: true,
        spaceBetween: 60,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: (index, className) =>
                `<span class="${className} !w-4 !h-4 !rounded-none"></span>`,
        },
        on: {
            init: function() {
                updateSlideContent(this.realIndex);
            },
            slideChange: function() {
                updateSlideContent(this.realIndex);
            }
        }
    });

    // Company History Sliders Configuration
    const historySliders = new Swiper('#history2010, #history2000, #history1990, #history1980', {
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
        },
    });

    // Products
    const products = new Swiper('#productTheEl, #productIxel, #productLuxen, #productYzer, #productEscalator',{
        slidesPerView: 1,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        navigation: {
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
        },
    });
});
